import { alpha, type SxProps, type Theme } from '@mui/material';

const appDataGridSx: SxProps<Theme> = (theme) => {
  const headerBackground = theme.palette.background.default;
  const line = theme.palette.divider;

  return {
    '--DataGrid-rowBorderColor': line,
    border: '1px solid',
    borderColor: line,
    borderRadius: '10px',
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    overflow: 'hidden',
    fontSize: '0.875rem',
    boxShadow: `0 1px 2px ${alpha(
      theme.palette.common.black,
      theme.palette.mode === 'dark' ? 0.2 : 0.03,
    )}`,
    '& .MuiDataGrid-columnHeaders': {
      '--DataGrid-containerBackground': headerBackground,
      backgroundColor: headerBackground,
      borderBottom: `1px solid ${line}`,
    },
    '& .MuiDataGrid-columnHeader': {
      '&:focus, &:focus-within': {
        outline: 'none',
      },
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      fontSize: '0.75rem',
      fontWeight: 700,
      letterSpacing: '0.04em',
      textTransform: 'uppercase',
      color: theme.palette.text.secondary,
    },
    '& .MuiDataGrid-columnSeparator': {
      display: 'none',
    },
    '& .MuiDataGrid-iconButtonContainer': {
      color: theme.palette.text.secondary,
    },
    '& .MuiDataGrid-cell': {
      display: 'flex',
      alignItems: 'center',
      borderBottom: `1px solid ${line}`,
      py: 0.5,
      '&:focus, &:focus-within': {
        outline: 'none',
      },
    },
    '& .MuiDataGrid-row:last-of-type .MuiDataGrid-cell': {
      borderBottom: 'none',
    },
    '& .MuiDataGrid-row': {
      cursor: 'pointer',
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest,
      }),
      '&:hover': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.mode === 'dark' ? 0.1 : 0.035,
        ),
      },
      '&.Mui-selected': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.mode === 'dark' ? 0.2 : 0.09,
        ),
        '&:hover': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            theme.palette.mode === 'dark' ? 0.26 : 0.13,
          ),
        },
      },
    },
    '& .MuiDataGrid-footerContainer': {
      borderTop: `1px solid ${line}`,
      backgroundColor: headerBackground,
      minHeight: 52,
    },
    '& .MuiTablePagination-root': {
      color: theme.palette.text.secondary,
    },
    '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
      fontSize: '0.8125rem',
    },
    '& .MuiCheckbox-root': {
      color: alpha(theme.palette.text.primary, 0.28),
    },
    '& .MuiCheckbox-root.Mui-checked, & .MuiCheckbox-root.MuiCheckbox-indeterminate':
      {
        color: theme.palette.primary.main,
      },
    '& .MuiDataGrid-toolbarContainer': {
      minHeight: 44,
      px: 1,
      borderBottom: `1px solid ${line}`,
      backgroundColor: theme.palette.background.paper,
    },
    '& .MuiDataGrid-cell--editing': {
      backgroundColor: alpha(
        theme.palette.primary.main,
        theme.palette.mode === 'dark' ? 0.16 : 0.06,
      ),
      boxShadow: `inset 0 0 0 1px ${theme.palette.primary.main}`,
    },
    '& .MuiDataGrid-cell--editing .MuiInputBase-root': {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.background.paper,
    },
    '& .MuiDataGrid-menuIconButton, & .MuiDataGrid-sortIcon, & .MuiDataGrid-filterIcon':
      {
        color: theme.palette.text.secondary,
      },
    '& .MuiDataGrid-overlayWrapperInner': {
      backgroundColor: theme.palette.background.paper,
    },
  };
};

export default appDataGridSx;
